import React from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  useMediaQuery,
  Button,
  Badge,
  Avatar,
  Menu,
  MenuItem,
  Divider,
  Box,
} from "@mui/material";
import {
  Menu as MenuIcon,
  Notifications as NotificationsIcon,
  AdminPanelSettings as AdminIcon,
  ExitToApp as LogoutIcon,
  Settings as SettingsIcon,
} from "@mui/icons-material";
import theme from "../../theme/theme";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";

interface HeaderProps {
  sidebarOpen: boolean;
  toggleSidebar: () => void;
}

const AdminDashboardHeader: React.FC<HeaderProps> = ({
  sidebarOpen,
  toggleSidebar,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [notifAnchorEl, setNotifAnchorEl] = React.useState<null | HTMLElement>(
    null
  );

  const handleMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotifOpen = (event: React.MouseEvent<HTMLElement>) => {
    setNotifAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setNotifAnchorEl(null);
  };

  const handleLogout = () => {
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("role");
    localStorage.removeItem("email");
    localStorage.removeItem("businessName");
    localStorage.removeItem("colorHex");
    navigate("/admin-login"); // Changed to admin login route
  };

  return (
    <AppBar
      position="fixed"
      sx={{
        zIndex: isMobile
          ? (theme) => theme.zIndex.drawer - 1
          : (theme) => theme.zIndex.drawer + 1,
        ml: sidebarOpen ? "240px" : 0,
        width: isMobile ? "100%" : sidebarOpen ? "calc(100% - 280px)" : "100%",
        backgroundColor: theme.palette.background.paper,
        color: theme.palette.text.primary,
        boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
        transition: (theme) =>
          theme.transitions.create(["width", "margin"], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between" }}>
        <Box display="flex" alignItems="center">
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={toggleSidebar}
            sx={{ mr: 2 }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            noWrap
            component="div"
            sx={{ fontWeight: 600 }}
          >
            Admin Portal
          </Typography>
        </Box>

        <Box display="flex" alignItems="center" gap={2}>
          {/* <IconButton color="inherit" onClick={handleNotifOpen} sx={{ p: 1 }}>
            <Badge badgeContent={4} color="error">
              <NotificationsIcon />
            </Badge>
          </IconButton> */}

          <IconButton onClick={handleMenuOpen} sx={{ p: 0 }}>
            <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
              <AdminIcon />
            </Avatar>
          </IconButton>
        </Box>

        {/* User Menu Dropdown */}
        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          PaperProps={{
            elevation: 0,
            sx: {
              mt: 1.5,
              minWidth: 200,
              borderRadius: 2,
              boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
            },
          }}
        >
          <MenuItem disabled>
            <Box display="flex" flexDirection="column">
              <Typography variant="subtitle2">Admin User</Typography>
              <Typography variant="caption" color="textSecondary">
                Super Admin
              </Typography>
            </Box>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose}>
            <SettingsIcon sx={{ mr: 1.5, fontSize: 20 }} />
            Settings
          </MenuItem>
          <MenuItem onClick={handleLogout}>
            <LogoutIcon sx={{ mr: 1.5, fontSize: 20 }} />
            Logout
          </MenuItem>
        </Menu>

        {/* Notifications Dropdown */}
        <Menu
          anchorEl={notifAnchorEl}
          open={Boolean(notifAnchorEl)}
          onClose={handleClose}
        >
          <MenuItem disabled>
            <Typography variant="subtitle2">Notifications (4)</Typography>
          </MenuItem>
          <Divider />
          <MenuItem onClick={handleClose}>
            <Typography variant="body2">New carrier registration</Typography>
          </MenuItem>
          <MenuItem onClick={handleClose}>
            <Typography variant="body2">
              System maintenance scheduled
            </Typography>
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
};

export default AdminDashboardHeader;
